import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withFirestore } from 'react-redux-firebase';
import { getCampaigns } from '../../../store/selectors/campaigns';
import { getDealList } from '../../../store/selectors/deals';

const styles = theme => ({
  root: {
    width: '100%',
    minHeight: '500px',
    maxWidth: 1300,
    margin: '0 auto'
  },
  layout: {
    width: '100%',
    background: '#f5f6fa',
    paddingTop: theme.spacing.unit * 7,
    paddingBottom: theme.spacing.unit * 10,
    paddingLeft: theme.spacing.unit * 4,
    paddingRight: theme.spacing.unit * 4,
    [theme.breakpoints.up(600 + theme.spacing.unit * 4 * 2)]: {
      width: '100%',
      boxSizing: 'content-box'
    }
  },
  listRow: {
    padding: 24,
    borderBottom: '1px solid #c5c5c5',
    display: 'flex',
    flexWrap: 'nowrap',
    [theme.breakpoints.down('xs')]: {
      display: 'block'
    },
    '&:nth-first-child': {
      paddingTop: 0
    },
    '&:nth-last-child': {
      paddingBottom: 30,
      borderBottom: 'none'
    }
  },
  dealStatusIcon: {
    width: '20px',
    marginRight: '10px'
  },
  detailsButton: {
    color: 'white'
  },
  noCampText: {
    paddingTop: '220px'
  },
  createCampLink: {
    color: '#22c26e'
  }
});

const mapStateToProps = state => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
    campaigns: getCampaigns(state),
    deals: getDealList(state)
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withFirestore,
  withProps(({ profile, auth }) => ({
    profile,
    auth
  })),
  withStyles(styles),
  withRouter
);



// WEBPACK FOOTER //
// ./src/components/company/my-campaigns/MyCampaigns.enhancer.js